$(document).ready( function() {

    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
        event.preventDefault();

        $(this).ekkoLightbox({
            wrapping: true,
            alwaysShowClose: false,

            onShow:function(){
                $("#"+this._modalId).append(
                    "<button type='button' class='close modal-close' data-dismiss='modal' aria-label='Close'><span class='left'></span><span class='right'></span></button>"+
                    "<div class='ekko-nav'><div class='ekko-left'><i class=\"fas fa-angle-left\"></i></div><div class='ekko-right'><i class=\"fas fa-angle-right\"></i></div></div>"
                );
                $("#"+this._modalId + " .modal-footer").clone().appendTo("#"+this._modalId);

                $(".ekko-left").on("click", function () {
                    $(this).parent().siblings(".modal-dialog").find(".ekko-lightbox-nav-overlay > a:first-of-type").click();
                })
                $(".ekko-right").on("click", function () {
                    $(this).parent().siblings(".modal-dialog").find(".ekko-lightbox-nav-overlay > a:nth-of-type(2)").click();
                })
            },

        });

    });


    // Lightbox update image title functions
    $(document).on('click', ".update-image", function (event) {
        event.preventDefault();
        var parent = $(this).closest('.card-item');
        parent.find('.update-field').prop("disabled", false).css("color","#000").addClass('active-input');
        parent.find('.btn.update-btn.d-none').removeClass("d-none").prop("disabled", false);
    });

    $(document).on('click', ".update-btn ", function (pff) {
        // pff.preventDefault();
        var parent = $(this).closest('.card-item');
        parent.find('.update-wrapper').addClass('was-validated');
        parent.find('.update-field').removeClass('active-input');
        console.log($(this).find('.update-field'));

    });



});
